import { Link } from "@reach/router";
import React from "react";
import styled from "styled-components";
//
export default ({ closeTitle, closeTo, children, handleClose }) => (
	<Popup>
		<Close>
			<Link
				to={closeTo}
				title={closeTitle}
				onClick={(e) => (handleClose ? handleClose(e) : true)}
			>
				Close
			</Link>
		</Close>
		<Content>{children}</Content>
	</Popup>
);
//
const Popup = styled.div`
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.9);
  bottom: 0;
  left: 0;
  overflow: auto;
  padding: 1rem;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 2000;

  @media (min-width: 768px) {
    padding: 1rem 2rem;
  }

  @media (min-width: 1080px) {
    padding: 1rem 6rem;
  }
`;

const Close = styled.div`
  color: #000;
  font-size: 10px;
  padding: 1rem;
  position: fixed;
  right: 0;
  top: 0;
  text-transform: uppercase;

  @media (min-width: 768px) {
    right: 2rem;
    top: 2rem;
  }
`;

const Content = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100%;
  padding: 1rem 0;
  width: 100%;
`;
